import { render, staticRenderFns } from "./register-sample.vue?vue&type=template&id=2a9e0aa7"
import script from "./register-sample.vue?vue&type=script&lang=js"
export * from "./register-sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports